import React, { useEffect, useState } from "react";
import TextInput from "../form/TextInput";
import PasswordInput from "../form/PasswordInput";
import { Button } from "../ui/button";
import { resetPassword } from "@/api/auth";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "@/hooks/use-toast";

function ResetPasswordForm() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // Use useSearchParams instead
  const token = searchParams.get("token");

  const [newPw, setNewPw] = React.useState("");
  const [confirmPw, setConfirmPw] = React.useState("");

  const [err, setErr] = useState<string>("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isValid()) {
      return;
    }
    // Call API to reset password
    const res = await resetPassword({ token: token!, newPassword: newPw });
    if (res) {
      toast({
        title: "Password reset successful",
        description: "You can now login with your new password.",
      });
      setNewPw("");
      setConfirmPw("");
      setErr("");
      navigate("/login");
    } else {
      toast({
        title: "Error",
        description: "Failed to reset password. Please try again.",
      });
    }
  };
  if (!token) {
    console.log("no token");
    return <Navigate to="/login" replace />;
  }

  const isValid = () => {
    if (newPw.length === 0 || confirmPw.length === 0) {
      setErr("Please fill in all fields.");
      return false;
    }
    if (newPw !== confirmPw) {
      setErr("Passwords do not match.");
      return false;
    }
    return true;
  };
  return (
    <div className="w-full h-full flex flex-col gap-4 items-center justify-center">
      <div className="flex flex-col gap-2">
        <div className="text-2xl font-bold text-center">Reset Password</div>
        <div className="text-gray-500 text-center">
          Please enter a new password for your account.
        </div>
      </div>
      <form
        onSubmit={handleSubmit}
        className=" mt-10 w-full h-max flex flex-col gap-6 items-center max-w-[400px]"
      >
        <PasswordInput label="New Password" value={newPw} setValue={setNewPw} />
        <PasswordInput
          label="Confirm Password"
          value={confirmPw}
          setValue={setConfirmPw}
        />
        <div className="text-red-500 text-sm h-6 w-full">{err}</div>
        <Button
          className="w-full"
          type="submit"
          disabled={confirmPw.length === 0 || newPw.length === 0}
        >
          Reset Password
        </Button>
      </form>
    </div>
  );
}
export default ResetPasswordForm;
